import { styled, Box } from "@mui/material";

export const StyledCircularProgress = styled(Box)({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '80vh',
});
